import { generateTableSlice } from "./tableSlice";

const sliceAdminTable = generateTableSlice("admin");

export const ActionsAdminTable = sliceAdminTable.actions;
export const ReducerAdminTable = sliceAdminTable.reducer;
